import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import { findSubjectIcon, LyceoSubjectIcon } from '@lyceo/shared/util';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faGraduationCap,
  faPlus,
  faBook,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import {
  ButtonComponent,
  CssVarPipe,
  ProgressBarComponent,
  SkeletonTextComponent,
  SubjectIconComponent,
} from '@lyceo/shared/ui';

@Component({
  selector: 'lyceo-practise-card',
  imports: [
    ProgressBarComponent,
    CssVarPipe,
    SubjectIconComponent,
    SkeletonTextComponent,
    ButtonComponent,
    FaIconComponent,
  ],
  templateUrl: './practise-card.component.html',
  styleUrls: ['./practise-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'lyceo-practise-card',
    '[class.is-empty]': 'empty()',
  },
})
export class PractiseCardComponent {
  public readonly empty: InputSignal<boolean> = input<boolean>(false);
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly subjectName: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly graduationIcon: InputSignal<boolean> = input<boolean>(false);
  public readonly bookIcon: InputSignal<boolean> = input<boolean>(false);
  public readonly progressTitle: InputSignal<string | undefined> = input<
    string | undefined
  >();
  public readonly total: InputSignal<number | undefined> = input<
    number | undefined
  >();
  public readonly progress: InputSignal<number | undefined> = input<
    number | undefined
  >();

  protected readonly icon: Signal<LyceoSubjectIcon> = computed(() =>
    findSubjectIcon(this.subjectName()),
  );
  protected readonly faPlus: IconDefinition = faPlus;
  protected readonly faBook: IconDefinition = faBook;
  protected readonly faGraduationCap: IconDefinition = faGraduationCap;
}
